import React from "react"

export default function Footer(props) {
  return (<footer><small>{props.icon_credits}</small></footer>);
}
